import manager from 'app/module46/component-manager.js';

manager.register('tabs', tabs);

/**
 * @param {Element} component
 * @param {Object.<string, Element>} references
 * @param {Array.<Element>} references.tabContents
 * @param {Array.<Element>} references.tabLinks
 * @param {Object.<string, string>} attributes
 * @param {Object.<string, string>} properties
 */
function tabs(component, references, attributes, properties) {

	const {
		tabContents,
		tabLinks,
	} = references;

	const linkRefs = {};
	const contentRefs = {};

	/** @type {null|Element} */
	let activeContent = null;
	/** @type {null|Element} */
	let activeLink = null;
	/** @type {null|Element} */
	let firstLink = null;

	/** @type {string} */
	let hash = window.location.hash;
	if (hash.length > 0) {
		hash = hash.substring(1);
	}

	// Si les éléments ne sont pas présents
	if (tabLinks === undefined || tabContents === undefined) {
		return false;
	}

	for (const tabLink of tabLinks) {
		const currentTabName = getTabName(tabLink.id);
		tabLink.tabName = currentTabName;

		linkRefs[currentTabName] = tabLink;

		tabLink.addEventListener('click', function () {
			closeAllTabs();
			openTab(currentTabName);
		});

		if (tabLink.classList.contains('active')) {

			if (activeLink !== null) {
				activeLink.classList.remove('active');
			}

			activeLink = tabLink;
		}

		if (firstLink === null) {
			firstLink = tabLink;
		}
	}

	for (const tabContent of tabContents) {
		const currentTabName = getTabName(tabContent.id);
		tabContent.tabName = currentTabName;

		contentRefs[currentTabName] = tabContent;

		if (tabContent.classList.contains('active')) {

			if (activeContent !== null) {
				activeContent.classList.remove('active');
			}

			activeContent = tabContent;
		}
	}

	if (hash && hash.includes('tab-')) {
		closeAllTabs();

		openTab(hash);
		return false;

	} else if (activeLink === null) {
		openTab(firstLink?.tabName)

	} else {
		openTab(activeLink?.tabName)
	}


	function openTab(currentTabName) {
		contentRefs[currentTabName]?.classList.add('active');
		activeContent = contentRefs[currentTabName];

		linkRefs[currentTabName]?.classList.add('active');
		activeLink = linkRefs[currentTabName];
	}

	function closeAllTabs() {
		activeLink?.classList.remove('active');
		activeContent?.classList.remove('active');
	}

	function getTabName(id) {
		return id.split('-')[1].trim();
	}
}
